import { IconType } from '@/ui';
import { GeneralNavigationType, Link, Links } from '../types/types';
import { CompanyTypes, PermissionName } from '@/types';
import { ROUTES } from './constants';

export const getLinks = (linkGroup: string, companyType: CompanyTypes): Link[] => {
  if (companyType === CompanyTypes.ROOT) {
    return links[linkGroup];
  }
  return links[linkGroup]?.filter((link: Link) => link.permission !== PermissionName.ORGANIZATION);
};

export const links: Links = {
  cdk: [
    {
      type: 'Compass',
      hasDropdown: false,
      href: `${ROUTES.CDK}/${ROUTES.DASHBOARD}`,
      text: 'dashboard',
    },
    {
      type: 'Building',
      hasDropdown: false,
      href: `${ROUTES.CDK}/${ROUTES.ORGANIZATIONS}`,
      text: 'organizations',
      permission: PermissionName.ORGANIZATION,
    },
    {
      type: 'Bag',
      hasDropdown: false,
      href: `${ROUTES.CDK}/${ROUTES.COMPANIES}`,
      text: 'companies',
    },
    {
      type: 'Finances',
      hasDropdown: false,
      href: `${ROUTES.CDK}/${ROUTES.RESIDUALS}`,
      text: 'residuals',
    },
    // {
    //   type: 'Book',
    //   hasDropdown: false,
    //   href: `${ROUTES.CDK}/${ROUTES.LIBRARY}`,
    //   text: 'build_library',
    // },
    {
      type: 'Ruby',
      hasDropdown: false,
      href: `${ROUTES.CDK}/${ROUTES.PLANS}`,
      text: 'plans',
      permission: PermissionName.PLANS,
    },
    {
      type: 'Settings',
      hasDropdown: false,
      href: `${ROUTES.CDK}/${ROUTES.SETTINGS}`,
      text: 'settings',
    },
  ],
};

export const GeneralMenuLinks: GeneralNavigationType[] = [
  {
    type: IconType.Store,
    fill: 'var(--oliver-base-blue)',
    permission: PermissionName.STORE,
    text: 'home',
    href: '/store/',
  },
  {
    type: IconType.Builder,
    fill: 'var(--oliver-base-blue)',
    permission: PermissionName.BUILDER,
    text: 'builder',
    href: '/builder/',
  },
  {
    type: IconType.Payments,
    fill: 'transparent',
    href: '/payments',
    text: 'final_pay',
    permission: PermissionName.PAYMENT,
  },
  {
    type: IconType.Chain,
    fill: 'var(--oliver-base-blue)',
    permission: PermissionName.STORE,
    href: '/integrations',
    text: 'integrations',
  },
];

export const settingLink: Link = {
  type: 'Settings',
  text: '',
  hasDropdown: false,
  href: `${ROUTES.CDK}/${ROUTES.SETTINGS}`,
};
